import React from 'react';
import './ui.css';

/**
 * Stepper — horizontal progress stepper.
 * Props:
 *   steps: [{ key, label }]
 *   currentIndex: number (0-based; steps before are "complete", at is "current")
 *   onStepClick?: (key, index) => void
 */
export default function Stepper({ steps = [], currentIndex = 0, onStepClick }) {
  return (
    <ol className="ui-stepper">
      {steps.map((step, idx) => {
        const state =
          idx < currentIndex ? 'complete' :
          idx === currentIndex ? 'current' : 'upcoming';
        const cls = `ui-stepper__step ui-stepper__step--${state}`;
        const clickable = typeof onStepClick === 'function';
        return (
          <React.Fragment key={step.key ?? idx}>
            <li>
              <button
                type="button"
                className={cls}
                onClick={clickable ? () => onStepClick(step.key, idx) : undefined}
                disabled={!clickable}
                aria-current={state === 'current' ? 'step' : undefined}
              >
                <span className="ui-stepper__dot" aria-hidden="true">
                  {state === 'complete' ? '✓' : idx + 1}
                </span>
                <span className="ui-stepper__label">{step.label}</span>
              </button>
            </li>
            {idx < steps.length - 1 && (
              <span
                className={`ui-stepper__connector ${idx < currentIndex ? 'ui-stepper__connector--complete' : ''}`}
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        );
      })}
    </ol>
  );
}
